module.exports = __webpack_public_path__ + "img/airflow.add5d5f4.svg";